import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { closeFeedbackPopup, openFeedbackSentPopup, openForm } from '../../../../actions/feedback';
import { QuestionBlock } from './QuestionBlock';

export const QuestionBlockContainer = connect(undefined, (dispatch: Dispatch<{}>) => ({
  onYesButtonClick() {
    dispatch(closeFeedbackPopup());
    dispatch(openFeedbackSentPopup());
  },
  onNoButtonClick() {
    dispatch(openForm());
  },
  onDidNotPickUpPhoneButtonClick() {
    dispatch(closeFeedbackPopup());
    dispatch(openFeedbackSentPopup());
  },
}))(QuestionBlock);
